import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";

import IDasn from "Types/Dasn";
import _ from "lodash";
import ResultModel from "models/ResultModel";

export const GET_DASN = "[DASN] GET_DASN";
export const GET_DASN_SUCCESS = "[DASN] GET_DASN_SUCCESS";
export const GET_DASN_FAILED = "[DASN] GET_DASN_FAILED";

export const GENERATE_DASN = "[DASN] GENERATE_DASN";
export const GENERATE_DASN_SUCCESS = "[DASN] GENERATE_DASN_SUCCESS";
export const GENERATE_DASN_FAILED = "[DASN] GENERATE_DASN_FAILED";

export const SEND_DASN = "[DASN] SEND_DASN";
export const SEND_DASN_SUCCESS = "[DASN] SEND_DASN_SUCCESS";
export const SEND_DASN_FAILED = "[DASN] SEND_DASN_FAILED";

export const SET_VALUE = "[DASN] SET_VALUE";
export const CLEAR_VALUES = "[DASN] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function declareDasnes(data: any[], callback?: Callback<IDasn[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GENERATE_DASN });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			const results: any[] = [];

			for (const chunk of chunks) {
				const response = await api.sendPost("/Dasn/Schedule/Declare", chunk, {
					Authorization: `Bearer ${login.token}`
				});

				const result = await response.json();

				results.push(...result.model);
			}

			dispatch({
				type: GENERATE_DASN_SUCCESS,
				payload: results
			});

			callback && callback(null, results);
		} catch (error) {
			return dispatch({
				type: GENERATE_DASN_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function sendDasn(data: any[], callback?: Callback<IDasn[]>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: SEND_DASN });

		try {
			const { login } = getState();

			const chunks = _.chunk(data, 100);

			let response: Response | any = null;

			const models: any[] = [];

			for (const chunk of chunks) {
				response = await api.sendPost("/Dasn/Schedule/Send", chunk, {
					Authorization: `Bearer ${login.token}`
				});

				const result: ResultModel<any[]> = await response.json();

				models.push(...(result.model || []));
			}

			dispatch({
				type: SEND_DASN_SUCCESS,
				payload: models
			});

			callback && callback(null, models);
		} catch (error) {
			return dispatch({
				type: SEND_DASN_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function send(
	id: string | string[],
	sendEmail: boolean,
	sendWhatsApp: boolean,
	callback?: Callback<any>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: SEND_DASN });

		try {
			const { login } = getState();

			let response: Response;
			if (Array.isArray(id)) {
				response = await api.sendPost(
					`/Dasn/Send`,
					{ id, sendEmail, sendWhatsApp },
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			} else {
				response = await api.sendPost(
					`/Dasn/${id}/Send`,
					{
						sendEmail,
						sendWhatsApp
					},
					{
						Authorization: `Bearer ${login.token}`
					}
				);
			}

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: SEND_DASN_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: SEND_DASN_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: SEND_DASN_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getDasn(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IBankBillet[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_DASN });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Dasn?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_DASN_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_DASN_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_DASN_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
